import { colors } from '../../colors';
import Next from '../../../../static/images/icons/Next';
import Prev from '../../../../static/images/icons/Prev';
var carousel = {
  arrowBgColor: colors.coral,
  arrowHoverBgColor: colors.rustRed,
  arrowForeColor: colors.white,
  arrowPrevMarginRightVarA: '4px',
  arrowNextMarginLeftVarA: '4px',
  highlightColor: colors.ash,
  paginationInactiveColor: colors.white,
  paginationActiveColor: colors.coral,
  paginationBorderColor: colors.coral,
  heroPaginationBorder: false,
  noBorderOnDesktopVariationAandB: true,
  heroPaginationInactiveColor: colors.white,
  heroPaginationInactiveColorMobile: colors.coral,
  heroPaginationInactiveColorVariationC: colors.coral,
  heroPaginationActiveColor: colors.coral,
  heroPaginationBorderColor: colors.rustRed,
  bgColor: colors.white,
  iconNext: Next,
  iconPrev: Prev
};
export default carousel;